import { Platform } from '../../types/Platforms';
import { RevenueSource } from '../../types/RevenueSource';
import { RevenueSourceType } from '../../types/RevenueSourceType';
import { RestaurantSectionType } from '../../types/RestaurantSectionType';

export type DataSourceType = 'supplier' | 'revenue';

export type WizardStep =
  | 'chooseType'
  | 'selectSection'
  | 'selectSupplier'
  | 'configureSupplier'
  | 'configureRevenue'
  | 'emailForwarding'
  | 'confirmation';

export interface WizardState {
  type: DataSourceType | null;
  // Supplier
  sectionId: string | null;
  sectionName: string | null;
  sectionType: RestaurantSectionType | null;
  isNewSection: boolean;
  platform: Platform | null;
  orderEmails: string[];
  orderClientNames: string[];
  // Revenue
  revenueSourceName: RevenueSource | null;
  revenueSourceType: RevenueSourceType | null;
  restaurantNameInPOS: string;
  relevantSections: string[];
}

export const initialWizardState: WizardState = {
  type: null,
  sectionId: null,
  sectionName: null,
  sectionType: null,
  isNewSection: false,
  platform: null,
  orderEmails: [],
  orderClientNames: [],
  revenueSourceName: null,
  revenueSourceType: null,
  restaurantNameInPOS: '',
  relevantSections: [],
};
